// Modules
import { Route, Switch, useRouteMatch, useLocation } from 'react-router-dom';

// Components
import { StyledTitle } from '../../common/components';
import { MeterUpgradeChooseSite } from './sites-step';
import { MeterUpgradeContactDetails } from './sites-step/MeterUpgradeContactDetails';
import { MeterUpgradeConfirmation } from './sites-step/MeterUpgradeConfirmation';
import { MeterUpgradeProcessProvider } from './meterUpradeProcess/meterUpgradeProcessProvider';

// Styles
import { ProcessStepsWrapper } from './MeterUpgrade.styles';
import { ProcessStepIndicatorMovingPremises } from '../../common/components/ProcessStepIndicator/ProcessStepIndicatorMovingPremises';

const MeterUpgrade = () => {
  const { url, path } = useRouteMatch();
  const brand = process.env.REACT_APP_BRAND as 'drax' | 'opus';
  const steps = {
    drax: [
      { label: 'Site selection', routePath: '', component: MeterUpgradeChooseSite },
      { label: 'Contact details', routePath: '/contactdetails', component: MeterUpgradeContactDetails },
      { label: 'Confirmation', routePath: '/confirmation', component: MeterUpgradeConfirmation },
    ],
    opus: [
      { label: 'Select site', routePath: '', component: MeterUpgradeChooseSite },
      { label: 'Contact details', routePath: '/contactdetails', component: MeterUpgradeContactDetails },
      { label: 'Confirmation', routePath: '/confirmation', component: MeterUpgradeConfirmation },
    ],
  };
  const selectedSteps = steps[brand];

  const location = useLocation();

  const currentTabIndex = () => {
    const pathname = location.pathname;

    if (pathname.toUpperCase().endsWith('/METER-UPGRADE')) return 0;

    var ind: number = 0;
    for (const item of selectedSteps) {
      if (item.routePath.length === 0) {
        ind++;
      } else if (pathname.toUpperCase().endsWith(item.routePath.toUpperCase())) {
        break;
      } else {
        ind++;
      }
    }

    return ind;
  };

  const ProcessIndicator = (
    <ProcessStepsWrapper>
      {selectedSteps.map(({ label, routePath }, index) => {
        var visited = false;

        if (index <= currentTabIndex()) {
          visited = true;
        }

        return (
          <ProcessStepIndicatorMovingPremises
            key={`${url}${routePath}`}
            path={`${url}${routePath}`}
            step={index + 1}
            label={label}
            visited={visited}
          />
        );
      })}
    </ProcessStepsWrapper>
  );

  return (
    <div>
      <MeterUpgradeProcessProvider>
        <Switch>
          {selectedSteps.map(({ routePath, component: Component }) => (
            <Route exact key={`${path}${routePath}`} path={`${path}${routePath}`}>
              <Component stepsBar={ProcessIndicator} pageTitle={<StyledTitle>Meter upgrade</StyledTitle>} />
            </Route>
          ))}
        </Switch>
      </MeterUpgradeProcessProvider>
    </div>
  );
};
export default MeterUpgrade;
